import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../cn.js';
export function Label({ className, ...rest }) {
    return (_jsx("label", { className: cn('block text-sm font-medium text-on-surface', className), ...rest }));
}
//# sourceMappingURL=Label.js.map